import React, { useState } from "react";
import { footerNav } from "../../constants/footer";
import {
  BsLinkedin,
  BsTwitter,
  BsFacebook,
  BsYoutube,
  BsInstagram,
  BsTiktok,
} from "react-icons/bs";
import { applestore, googleplay } from "../../assets/images";
import { Link } from "react-router-dom";
import { IoClose, IoHourglassOutline } from "react-icons/io5";

const Footer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClick = () => {
    setIsModalOpen(true);
  };
  return (
    <div className="w-full bg-midGreen">
      <div className="w-full md:w-4/5 flex flex-col gap-8 mx-auto p-5 md:p-[64px] justify-around">
        <div className="flex flex-wrap gap-[60px]">
          <div className="flex flex-wrap md:flex-nowrap  gap-12">
            {footerNav.map((nav, index) => (
              <div className="w-[20%] flex flex-col gap-2 md:gap-6" key={index}>
                <div className="text-white font-Inter text-[15px] md:text-[18px] capitalize leading-7  font-bold">
                  {nav.head}
                </div>
                {nav.links.map((link, index) => (
                  <div
                    className="text-white text-[13px] md:tex-[16px] flex flex-col gap-3 font-normal leading-4 cursor-pointer"
                    key={index}
                  >
                    <Link to={link.path} className="px-2 cursor-pointer">
                      {link.name}
                    </Link>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col-reverse gap-9 md:gap-0 md:flex-row md:justify-between">
          <div className="flex gap-5 mx-auto md:mx-0 ">
            <BsLinkedin color="white" size={20} className="cursor-pointer " />
            <BsTwitter color="white" size={20} className="cursor-pointer" />
            <BsFacebook color="white" size={20} className="cursor-pointer" />
            <BsYoutube color="white" size={20} className="cursor-pointer" />
            <BsInstagram color="white" size={20} className="cursor-pointer" />
            <BsTiktok color="white" size={20} className="cursor-pointer" />
          </div>
          <div className="flex flex-col justify-start items-start  md:justify-end md:items-end">
            <div className="flex flex-col  gap-6 md:gap-[46px]">
              <div className="text-lightGreen font-Poppins text-[36px] font-normal ">
                Ecomoto
              </div>
              <div className="flex flex-col gap-5 ">
                <div onClick={() => handleClick()} className="flex gap-5 ">
                  <img src={applestore} alt="" className="cursor-pointer" />
                  <img src={googleplay} alt="" className="cursor-pointer" />
                </div>
                <div className="text-white text-[12px] font-normal leading-4">
                  © {new Date().getFullYear()} Ecomoto
                  <Link to="/policies/terms-of-service" className="px-2 cursor-pointer">
                    Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 py-5 sm:p-6 w-full">
                <div className="sm:flex flex-col gap-10 sm:items-start w-full mx-auto">
                  <div className="w-full ml-auto">
                    <button
                      aria-label="exit"
                      type="button"
                      className=" text-white rounded-full px-4 py-2 m-2"
                      onClick={() => setIsModalOpen(false)}
                    >
                      <IoClose className="h-6 w-6 text-black" />
                    </button>
                  </div>
                  <div className=" flex w-full flex-col justify-center gap-3 items-center">
                    <IoHourglassOutline
                      id="hourglass"
                      size={80}
                      className=" text-midGreen"
                    />
                    <h3
                      className="text-xl leading-6 font-medium font-Poppins text-darkGreen uppercase"
                      id="modal-title"
                    >
                      Coming Soon
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
